module.exports = __webpack_public_path__ + "img/code.01314750.jpg";